export const API_DEFAULT_BASE_URL = "https://api.sealevel.dev";
